export const BUTTON_BLUE = '#1B80C4';
export const TEXT_TITLE = '#394553';
export const TEXT_MAIN = '#60707C';
export const TEXT_SIGNATURE = '#B6C1CD';
export const BACKGROUND_LIGHT = '#EDF2F8';
export const SUCCESS_TEXT = '#47C41B';
export const BORDER_CHECKBOX = '#1B80C4';
export const BACKGROUND_CHECKBOX = '#F5F7FA';
export const RED = '#ff5f5f';
